export default __webpack_public_path__ + "static/media/foto5.8f9e2f9c.jpg";